import { render, staticRenderFns } from "./RegionsPage.vue?vue&type=template&id=275de684&"
import script from "./RegionsPage.vue?vue&type=script&lang=js&"
export * from "./RegionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports